import React from 'react';
import PropTypes from 'prop-types';
import {greyishBlue50} from "assets/jss/main";

import CustomSwitch from "components/switch/CustomSwitch";

MappingRow.propTypes = {
    title: PropTypes.string.isRequired,
    unmapped: PropTypes.number.isRequired,
    enabled: PropTypes.bool,
    isLast: PropTypes.bool,
    onToggle: PropTypes.func,
};

function MappingRow({
    title,
    unmapped,
    enabled = false,
    isLast = false,
    onToggle = () => {},
}) {
    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "12px 16px",
            borderBottom: isLast ? "none" : `1px solid ${greyishBlue50}`,
        }}>
            <div style={{lineHeight: '1rem'}}>
                <div style={{fontWeight: "700", fontSize: "14px", color: "#111827"}}>
                    {title}
                </div>
                <div style={{fontSize: "12px", color: "#9ca3af"}}>
                    {unmapped} valeurs non mappées
                </div>
            </div>

            <div style={{display: "flex", alignItems: "center", gap: "12px"}}>
                <span style={{
                    fontSize: "14px",
                    color: enabled ? "#6b7280" : "#9ca3af",
                    fontWeight: "500",
                }}>
                  {enabled ? "Auto" : "Manuel"}
                </span>
                <CustomSwitch checked={enabled} onClick={onToggle}/>
            </div>
        </div>
    );
}

export default MappingRow;
